
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getPriceList, addPrice, editorPrice, delPrice, setOtherPriceSetting } from '@/api/price';
import { getUserInfo } from '@/api/users';

@Component({
  name: 'SettingTemplatePrice',
  components: {

  }
})
export default class extends Vue {
  private formSearch = {
    name: ''
  }
private pagination:any={
  currentPage: 1,
  pageSize: 10,
  total: 0
}
  private tableData = []
  private dialogAddPriceVisible = false
  private isOtherPriceShow=false
  private isModifyOtherPrice=false
  private priceId=''

  private dialogPrice = {
    name: '',
    price: '',
    sort: 100
  }

  private rules = {
    name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
  }

  created() {
    this.isOtherPriceShow = parseInt((UserModule.getCompany as any).is_other_price_show) === 1;
    this.isModifyOtherPrice = parseInt((UserModule.getCompany as any).is_modify_other_price) === 1;
    this.getPriceList();
  }
  private searchHandle() {
    this.getPriceList();
  }
  private emptyHandle() {
    if (this.formSearch.name !== '') {
      this.formSearch.name = '';
      this.getPriceList();
    }
  }
  private handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getPriceList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getPriceList();
  }
  // 是否显示详情is_other_price_show
  private otherShowChange(val:any) {
    let parmas:any = {};
    parmas.user_id = UserModule.getUserId;
    parmas.company_id = UserModule.getCompanyId;
    parmas.is_other_price_show = val ? 1 : 0;
    setOtherPriceSetting(parmas).then(async(res:any) => {
      this.showSuccessMsg(res.msg);
      let parameters: any = {};
      parameters.user_id = UserModule.getUserId;
      parameters.company_id = UserModule.getCompanyId;
      await getUserInfo(parameters).then(async(res) => {
        await UserModule.setLogin(res.data);
      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private modifyOtherPriceChange(val:any) {
    let parmas:any = {};
    parmas.user_id = UserModule.getUserId;
    parmas.company_id = UserModule.getCompanyId;
    parmas.is_modify_other_price = val ? 1 : 0;
    setOtherPriceSetting(parmas).then(async(res:any) => {
      this.showSuccessMsg(res.msg);
      let parameters: any = {};
      parameters.user_id = UserModule.getUserId;
      parameters.company_id = UserModule.getCompanyId;
      await getUserInfo(parameters).then(async(res) => {
        await UserModule.setLogin(res.data);
      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private beforeClose() {
    this.dialogAddPriceVisible = false;
  }
  // 确认
  private addPriceHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        let parmas:any = {};
        parmas.user_id = UserModule.getUserId;
        parmas.company_id = UserModule.getCompanyId;
        parmas.price_name = this.dialogPrice.name;
        parmas.price_num = this.dialogPrice.price;
        parmas.sort = this.dialogPrice.sort;
        if (!this.priceId) {
          addPrice(parmas).then(res => {
            this.dialogPrice.name = '';
            this.dialogPrice.price = '';
            this.dialogPrice.sort = 100;
            this.dialogAddPriceVisible = false;
            this.showSuccessMsg((res as any).msg);
            this.getPriceList();
          }).catch(err => {
            this.showErrorMsg(err.msg);
          });
        } else {
          parmas.price_id = this.priceId;
          editorPrice(parmas).then(res => {
            this.dialogAddPriceVisible = false;
            this.showSuccessMsg((res as any).msg);
            this.getPriceList();
          }).catch(err => {
            this.showErrorMsg(err.msg);
          });
        }
      } else {
        return false;
      }
    });
  }
  // 添加
  private addPriceClick() {
    this.dialogAddPriceVisible = true;
    this.priceId = '';
    this.$set(this.dialogPrice, 'name', '');
    this.$set(this.dialogPrice, 'price', '');
    this.$set(this.dialogPrice, 'sort', 100);
  }
  // 编辑
  private editPriceHandle(price:any) {
    this.dialogAddPriceVisible = true;
    this.priceId = price.id;
    this.$set(this.dialogPrice, 'name', price.price_name);
    this.$set(this.dialogPrice, 'price', price.price_num);
    this.$set(this.dialogPrice, 'sort', price.sort);
  }
  // 删除费用
  private delPrice(price:any) {
    let parmas:any = {};
    parmas.user_id = UserModule.getUserId;
    parmas.company_id = UserModule.getCompanyId;
    parmas.price_id = price.id;
    delPrice(parmas).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getPriceList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 列表
  private getPriceList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    if (this.formSearch.name) {
      pamars.price_name = this.formSearch.name;
    }
    getPriceList(pamars).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = res.data.count;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      this.tableData = [];
      let msg = err.msg;
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
